import { render, staticRenderFns } from "./Communique.vue?vue&type=template&id=4b669ad0"
import script from "./Communique.vue?vue&type=script&lang=js"
export * from "./Communique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports